import { render } from "./ChangePasswordDialog.vue?vue&type=template&id=68d63bb6&scoped=true"
import script from "./ChangePasswordDialog.vue?vue&type=script&lang=js"
export * from "./ChangePasswordDialog.vue?vue&type=script&lang=js"

import "./ChangePasswordDialog.vue?vue&type=style&index=0&id=68d63bb6&scoped=true&lang=css"

import exportComponent from "C:\\Github\\dev-mynet\\Products\\Hub\\web\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d63bb6"]])

export default __exports__